// JsFromRoutes CacheKey 404e29b094576da78cd228602a56af4c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  updateTopics: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/media_sources/topics'),
  index: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/media_sources'),
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/media_sources'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/media_sources/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:org_nano_id/media_sources/:id'),
}
